export const START_GWS_SYNC = "START_GWS_SYNC";
export const START_GWS_SYNC_ERROR = "START_GWS_SYNC_ERROR";
export const START_GWS_SYNC_SUCCESS = "START_GWS_SYNC_SUCCESS";
export const PROGRESS_GWS_SYNC = "PROGRESS_GWS_SYNC";
export const PROGRESS_GWS_SYNC_ERROR = "PROGRESS_GWS_SYNC_ERROR";
export const PROGRESS_GWS_SYNC_SUCCESS = "PROGRESS_GWS_SYNC_SUCCESS";
export const CANCEL_GWS_SYNC = "CANCEL_GWS_SYNC";
export const CANCEL_GWS_SYNC_SUCCESS = "CANCEL_GWS_SYNC_SUCCESS";
export const CANCEL_GWS_SYNC_ERROR = "CANCEL_GWS_SYNC_ERROR";

/**
 * Start Google Workspace sync.
 * @param {Object} item - Municipal object.
 * @param {Object} history - React Router history.
 * @param {string} syncType - 'full' | 'delta'.
 */
export const startGwsSync = (item, history, syncType = "full") => ({
  type: START_GWS_SYNC,
  payload: {
    item,
    history,
    syncType,
  },
});

/**
 * Success action for starting GWS sync.
 * @param {Object} data - Started sync data.
 */
export const startGwsSyncSuccess = (data) => ({
  type: START_GWS_SYNC_SUCCESS,
  payload: data,
});

/**
 * Error action for starting GWS sync.
 * @param {Error|string} error - Error details.
 */
export const startGwsSyncError = (error) => ({
  type: START_GWS_SYNC_ERROR,
  payload: error,
});

/**
 * GWS sync process.
 * @param {string|number} id - Municipal ID.
 * @param {boolean} [loading=true] - Loading flag.
 * @returns {{ type: string, payload: Object }}
 */
export const progressGwsSync = (id, loading = true) => {
  return {
    type: PROGRESS_GWS_SYNC,
    payload: {
      id,
      loading,
    },
  };
};

/**
 * Action dispatched when GWS sync are successfully loaded.
 * @param {Object} data - Loaded log data.
 */
export const progressGwsSyncSuccess = (data) => ({
  type: PROGRESS_GWS_SYNC_SUCCESS,
  payload: data,
});

/**
 * Action dispatched when GWS sync fails.
 * @param {Error|Object|string} error - Error information.
 */
export const progressGwsSyncError = (error) => ({
  type: PROGRESS_GWS_SYNC_ERROR,
  payload: error,
});

/**
 * Cancel GWS sync job.
 * @param {string} jobId - Job ID to cancel.
 * @param {Object} [history] - React Router history for redirect.
 */
export const cancelGwsSync = (jobId, history) => ({
  type: CANCEL_GWS_SYNC,
  payload: { jobId, history },
});
